<style lang="less" scoped src="../css/common.less"></style>
<style lang="less" scoped>
    .content {
        margin-top: 20px;
        .sub-item-container {
            padding: 10px 10px 10px 71px;
        }
    }
    .sub-item-image{
        width: 50px;
        height: 50px;
        img {
            vertical-align: middle;
            max-width: 100%;
            max-height: 100%;
        }
    }
    .image-normal{
        display: inline-block;
        vertical-align: top;
        margin-right: 5px;
    }
</style>
<template>
    <div class="wrap" style="width: 700px">
        <h2 class="text-center">线下发货申请详情</h2>
        <div class="content" v-if="offline_order_detail.id">
          <Row class="line" :gutter="4">
            <i-col span="12">
              <div class="label">申请人</div>
              <div class="value">{{offline_order_detail.apply_user_name}}</div>
            </i-col>
          </Row>
          <Row>
            <i-col span="12">
              <div class="label">填制人</div>
              <div class="value">{{offline_order_detail.fill_user_name}}</div>
            </i-col>
          </Row>
          <Row class="line" :gutter="4">
            <i-col span="12">
              <div class="label">收件人</div>
              <div class="value">{{offline_order_detail.recv_user}}</div>
            </i-col>
          </Row>
          <Row class="line" :gutter="4">
            <i-col span="12">
              <div class="label">收件人留言</div>
              <div class="value">{{offline_order_detail.recv_user_note}}</div>
            </i-col>
          </Row>
          <Row class="line" :gutter="4">
            <i-col span="12">
              <div class="label">收件人手机号码</div>
              <div class="value">{{offline_order_detail.recv_contact}}</div>
            </i-col>
          </Row>
          <Row>
            <i-col span="12">
            <div class="label">配送省</div>
            <div class="value">{{offline_order_detail.province}}</div>
          </i-col>
          </Row>
          <Row class="line" :gutter="4">
            <i-col span="12">
              <div class="label">配送市</div>
              <div class="value">{{offline_order_detail.city}}</div>
            </i-col>
          </Row>
          <Row>
            <i-col span="12">
              <div class="label">配送县</div>
              <div class="value">{{offline_order_detail.area}}</div>
            </i-col>
          </Row>
          <Row class="line" :gutter="4">
            <i-col span="12">
              <div class="label">配送详细地址</div>
              <div class="value">{{offline_order_detail.recv_detail_address}}</div>
            </i-col>
          </Row>
          <Row>
            <i-col span="12">
              <div class="label">申请人留言</div>
              <div class="value">{{offline_order_detail.apply_user_note}}</div>
            </i-col>
          </Row>
          <Row class="line" :gutter="4">
            <i-col span="12">
              <div class="label">项目组</div>
              <div class="value">{{offline_order_detail.channel_name}}</div>
            </i-col>
          </Row>
          <Row>
            <i-col span="12">
              <div class="label">用途</div>
              <div class="value">{{util.offlineOrderSendUsage(offline_order_detail.usage)}}</div>
            </i-col>
          </Row>
          <Row>
            <i-col span="12">
              <div class="label">用途描述</div>
              <div class="value">{{offline_order_detail.usage_desc}}</div>
            </i-col>
          </Row>
          <Row class="line" :gutter="4">
            <i-col span="12">
              <div class="label">发货店铺</div>
              <div class="value">{{util.offlineOrderSendShop(offline_order_detail.shop)}}</div>
            </i-col>
          </Row>
          <Row>
            <i-col span="12">
              <div class="label">卖家备注</div>
              <div class="value">{{offline_order_detail.seller_note}}</div>
            </i-col>
          </Row>
          <Row class="line" :gutter="4">
            <i-col span="12">
              <div class="label">快递</div>
              <div class="value">{{delivery_type_map[offline_order_detail.delivery_type]}}</div>
            </i-col>
          </Row>

          <div
              v-for="(item, index) in this.offline_order_detail.offline_order_items"
              :key="index" >
            <div>
              <span>商品 - {{ index+1 }} </span>
            </div>
            <Row>
              <i-col span="12">
                <div class="label">{{item.sub_skus != null? '组合存货编码': '存货编码'}}</div>
                <div class="value">{{item.inner_name}}</div>
              </i-col>
            </Row>
            <Row>
              <i-col span="12">
                <div class="label">商品简称</div>
                <div class="value">{{item.short_name}}</div>
              </i-col>
            </Row>
            <Row>
              <i-col span="12">
                <div class="label">商品数量</div>
                <div class="value">{{item.count}}</div>
              </i-col>
            </Row>
            <Row>
              <i-col span="12">
                <div class="label">成本单价(元)</div>
                <div class="value">{{item.price/100}}</div>
              </i-col>
            </Row>
            <Row v-if="item.sub_skus != null">
              <i-col span="12">
                <div class="label">组合商品构成</div>
              </i-col>
            </Row>
            <Row v-if="item.sub_skus != null">
              <i-col span="2"/>
              <Table
                  :columns="sub_sku_columns"
                  :data=item.sub_skus
                  size="small"
                  border
              />
            </Row>
          </div>
        </div>

        <div>
          <div class="line user-flow" v-if="offline_order_detail.user_flow">
            <div class="label">流程状态</div>
            <div class="value">
              <UserFlow :user_flow="offline_order_detail.user_flow"></UserFlow>
            </div>
          </div>
      </div>
    </div>
</template>
<script>
    import UserFlowBase from '../../../../views/components/flow/user_flow_base';
    import Util from '../../../../libs/util'
    import UserFlow from '../../../components/flow/user_flow'
    export default {
        components: { UserFlowBase,UserFlow },
        props: {
            model_id: {
                type: Number,
            },
            type: {
              type: String
            },
            tip: {
              type: Boolean,
              default: true
            }
        },
        data(){
            return {
              util: Util,
              offline_order_detail_path: Util.api.offline_order_detail,
              offline_order_detail:'',
              delivery_type_map: {
                1: '普通快递',
                2: '顺丰陆运',
                3: '顺丰空运',
                4:'在库自提'
              },
              sub_sku_columns:[
                {
                  title: '存货编码',
                  key: 'code'
                },
                {
                  title: '商品简称',
                  key: 'name',
                  width: 200,
                },
                {
                  title: '单品用量',
                  key: 'count'
                },
              ]
            }
        },
        computed: {

        },
        created(){
          this.getOfflineOrderDetail();
        },
        mounted(){

        },
        methods: {
            getOfflineOrderDetail(){
              if(!this.loading){
                this.loading = true;
                Util.ajax.get(this.offline_order_detail_path, {params: {
                    id: this.model_id
                  }}).then((response) => {
                  return response.data;
                }).then((res) => {
                  if(res.code === 1){
                    this.offline_order_detail = res.data
                  }else{
                    this.$Modal.error({
                      title: '错误',
                      content: res.msg
                    });
                  }
                }).catch((e) => {
                  this.loading = false;
                  this.empty_tip = '获取数据失败, 请刷新页面重试';
                  console.log(e);
                });
              }
            }
        }
    }
</script>
